import React from 'react';

import Exact from './exact';

import {
  CreateConfigFn,
  nonAuthenticatedRedirect,
  pathJoin,
} from '../../../../routing/utils';

import { Roles } from '../../../../routing/child-router-factory';

import { TicketView } from '../../../shared/views/ticket/Ticket';

export type Keys = `exact` | ':ticketId';

export const createRoutesMap = (prefix: string) => ({
  ':ticketId': (containerId: string) => pathJoin(prefix)(containerId).chain,
});

const authenticatedUser: Roles = {
  and: ['authenticated'],
};

export const createConfig: CreateConfigFn<Keys> = (map) => [
  {
    key: ':ticketId',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,
    children: <TicketView />,
    path: map.app.containers[':ticketId'](':ticketId')._,
  },
  {
    key: 'exact',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,
    children: <Exact />,
    path: map.app.containers._,
    exact: true,
  },
];
